import React from "react"

import { withAddToCart } from "./withAddToCart"
import { Wrapper, Message } from "./AddToCartStyles"
import { BackInStock } from "../BackInStock/BackInStock"
import { StyledButton } from "../../Styled/Button"

export const AddToCart = withAddToCart(
  ({
    handleAddToCart,
    loading,
    selectedVariant,
    message,
    buttonText,
    isRestock,
    isOutOfStock,
    restockFormActive,
    setRestockFormActive,
    variantId,
    productId,
    url,
    hideGender,
    gender,
    sizeConversions,
  }): JSX.Element => (
    <>
      <Wrapper>
        {message ? <Message red={isOutOfStock || isRestock ? "true" : "false"}>{message}</Message> : null}
        <StyledButton
          wide={"true"}
          buttonMargin={"0"}
          onClick={isRestock ? () => setRestockFormActive(true) : handleAddToCart}
          disabled={!selectedVariant || loading || isOutOfStock}
        >
          {buttonText}
        </StyledButton>
      </Wrapper>
      <BackInStock
        restockFormActive={restockFormActive}
        setRestockFormActive={setRestockFormActive}
        variantId={variantId}
        productId={productId}
        url={url}
      />
    </>
  )
)
